<div class="view-tour-tip-button mv-1 mh-1" [ngSwitch]="!!icon">
    
    <!-- icon -->
    <ng-container *ngSwitchCase="true">
        <app-icon *ngIf="icon" [icon]="icon"></app-icon>
        <span *ngIf="icon" class="visually-hidden">{{ label }}</span>
    </ng-container>

    <!-- label -->
    <span *ngSwitchDefault>
        {{ label }}
    </span>

</div>